import { ProductPrice } from '~/Product';

import { ProductComputedPrice } from './ProductComputedPrice';

export class ReferencePrice {
	constructor(public readonly sourcePrice: ProductPrice, public readonly calculatedPrice: ProductComputedPrice) {}
}
